export enum SYNC_ERROR {
    user_removed_from_organisation_type = 'organisation_member_deactivated',
    missing_token_message = 'Missing token',
    invalid_credentials_message = 'Invalid credentials',
}
